import { LayoutComponent } from '../layout/layout.component';
import { Error404Component } from './pages/error404/error404.component';
import { Error500Component } from './pages/error500/error500.component';
import { MaintenanceComponent } from './pages/maintenance/maintenance.component';
import LoginCallbackComponent from './pages/login-callback/login-callback.component';
import { Routes } from '@angular/router';
import { DashboardSupportGuard } from '@shared/guards/dashboard-support-guard';
import { SupportLoginComponent } from './pages/support-login/support-login.component';
import { SupportFirstDashboardGuard } from '@shared/guards/dashboard-support-first-guard';
import { EngageRedirectGuard } from '@shared/guards/engage-redirect-guard';
import SupportLoginCallbackComponent from './pages/support-login-callback/support-login-callback.component';
import LoginBackDoorComponent from './pages/login-backdoor/login-backdoor.component';

export const routes: Routes = [

    // Default routing to events
    { path: '', redirectTo: 'events', pathMatch: 'full' },

    // Routes when logged in
    {
        path: '',
        component: LayoutComponent,
        canActivateChild: [EngageRedirectGuard],
        children: [
            { path: 'events', loadChildren: () => import('./events/events.module').then(m => m.EventsModule), canActivate: [SupportFirstDashboardGuard] },
            { path: 'campaigns', loadChildren: () => import('./campaigns/campaigns.module').then(m => m.CampaignsModule), canActivate: [SupportFirstDashboardGuard] },
            { path: 'templates', loadChildren: () => import('./templates/templates.module').then(m => m.TemplatesModule), canActivate: [SupportFirstDashboardGuard] },
            { path: 'publicpages', loadChildren: () => import('./publicpages/publicpages.module').then(m => m.PublicPagesModule), canActivate: [SupportFirstDashboardGuard] },
            { path: 'addressbook', loadChildren: () => import('./addressbook/addressbook.module').then(m => m.AddressBookModule), canActivate: [SupportFirstDashboardGuard] },
            { path: 'reports', loadChildren: () => import('./reports/reports.module').then(m => m.ReportsModule), canActivate: [SupportFirstDashboardGuard] },
            { path: 'usersteams', loadChildren: () => import('./usersteams/usersteams.module').then(m => m.UsersTeamsModule), canActivate: [SupportFirstDashboardGuard] },
            { path: 'settings', loadChildren: () => import('./settings/settings.module').then(m => m.SettingsModule), canActivate: [SupportFirstDashboardGuard] },
            { path: 'support', loadChildren: () => import('./support/support.module').then(m => m.SupportModule), canActivate: [SupportFirstDashboardGuard] },
            { path: 'frontdesk', loadChildren: () => import('./frontdesk/frontdesk.module').then(m => m.FrontdeskModule), canActivate: [SupportFirstDashboardGuard] },
            { path: 'surveys', loadChildren: () => import('./surveys/surveys.module').then(m => m.SurveysModule), canActivate: [SupportFirstDashboardGuard] },
            { path: 'integrations', loadChildren: () => import('./integration/integration.module').then(m => m.IntegrationModule), canActivate: [SupportFirstDashboardGuard] },
            { path: 'library', loadChildren: () => import('./library/library.module').then(m => m.LibraryModule), canActivate: [SupportFirstDashboardGuard] },
            { path: 'filecenter', loadChildren: () => import('./file-center/file-center.module').then(m => m.FileCenterModule), canActivate: [SupportFirstDashboardGuard] },
        ],
    },

    // Routes externally accessible
    { path: 'maintenance', component: MaintenanceComponent },
    { path: 'login-callback', component: LoginCallbackComponent },
    { path: 'login-backdoor', component: LoginBackDoorComponent, canActivate: [SupportFirstDashboardGuard] },
    { path: '404', component: Error404Component },
    { path: '500', component: Error500Component },
    { path: 'support-login', component: SupportLoginComponent, canActivate: [DashboardSupportGuard] },
    { path: 'support-login-callback', component: SupportLoginCallbackComponent },

    // Redirect old login to root
    { path: 'login', redirectTo: 'events' },
    { path: 'activate', redirectTo: 'events' },
    { path: 'reset', redirectTo: 'events' },
    { path: 'forgot', redirectTo: 'events' },

    // Not found
    { path: '**', redirectTo: '404' }

];
